import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import pages from '@/data/pages.json';

const routes = pages.pages.map(page => ({
  path: page.to,
  name: page.name.toLowerCase(),
  component: page.name === 'Home'
    ? HomeView
    : () => import(`../views/${page.name}View.vue`),
}));

// Preserve old links while keeping their content on the home page.
routes.push(
  { path: '/Contact', redirect: { path: '/', hash: '#reach-us' } },
  { path: '/Ecosystem', redirect: { path: '/', hash: '#ecosystem' } },
);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    if (from === START_LOCATION) return false;
    return { top: 0 };
  },
});

export default router;
